module.exports = __webpack_public_path__ + "img/marietas-puerto-vallarta.36778a44.jpg";